import { render, staticRenderFns } from "./ItemSidebarLinks.vue?vue&type=template&id=d0e72d8a"
import script from "./ItemSidebarLinks.vue?vue&type=script&lang=js"
export * from "./ItemSidebarLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports